import React, { useState } from 'react';
import './Header.css';
import logo from '../assets/logo.png';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false); // Close mobile menu after clicking
  };

  return (
    <header className="header">
      <div className="header-container">
        {/* Logo */}
        <div className="header-logo">
          <img src={logo} alt="San Mateo Orthodontics" />
        </div>

        {/* Desktop Navigation */}
        <nav className="header-nav desktop-nav">
          <ul>
            <li>
              <button onClick={() => scrollToSection('services')}>Services</button>
            </li>
            <li>
              <button onClick={() => scrollToSection('office')}>Our Office</button>
            </li>
            <li>
              <button onClick={() => scrollToSection('staff')}>Our Staff</button>
            </li>
            <li>
              <button onClick={() => scrollToSection('contact')}>Contact</button>
            </li>
            <li>
              <button
                onClick={() => window.open('https://bestcardteam.com/Payments?Profile=ellerhorstddsWEB', '_blank')}
                className="pay-online-button"
              >
                Pay Online
              </button>
            </li>
          </ul>
          <button
            className="header-cta-button"
            onClick={() => scrollToSection('registration')}
          >
            New Patient Registration
          </button>
        </nav>

        {/* Mobile Menu Button */}
        <button
          className="mobile-menu-button"
          onClick={toggleMenu}
          aria-label="Toggle navigation menu"
          aria-expanded={isMenuOpen}
        >
          <span className={`hamburger ${isMenuOpen ? 'open' : ''}`}>
            <span></span>
            <span></span>
            <span></span>
          </span>
        </button>

        {/* Mobile Navigation */}
        <nav className={`header-nav mobile-nav ${isMenuOpen ? 'open' : ''}`}>
          <ul>
            <li>
              <button onClick={() => scrollToSection('services')}>Services</button>
            </li>
            <li>
              <button onClick={() => scrollToSection('office')}>Our Office</button>
            </li>
            <li>
              <button onClick={() => scrollToSection('staff')}>Our Staff</button>
            </li>
            <li>
              <button onClick={() => scrollToSection('contact')}>Contact</button>
            </li>
            <li>
              <button
                onClick={() => {
                  window.open('https://bestcardteam.com/Payments?Profile=ellerhorstddsWEB', '_blank');
                  setIsMenuOpen(false);
                }}
                className="pay-online-button"
              >
                Pay Online
              </button>
            </li>
          </ul>
          <button
            className="header-cta-button"
            onClick={() => scrollToSection('registration')}
          >
            New Patient Registration
          </button>
        </nav>
      </div>
    </header>
  );
};

export default Header; 